<template>      
    <div id="ubn" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('missing.Missing_from_UBN') }}</h5>
        <p class="text-sm">{{ $t('common.Mandatory_informations') }} *</p>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-8">
            <div class="input-group input-group-static null">
                <label>{{ $t('missing.Missing_from_UBN') }} *</label>
                <select id="ubnId" v-model="state.ubnId" class="form-control form-control-default">
                    <option value="">{{ $t('missing.Select_UBN') }}</option>
                    <option v-for="item in state.ubns" :key="item.id" :value="item.id">
                        {{ item.ubn }} - {{ item.locationFullAddressDropDown }}
                    </option>
                </select>
                <span v-if="vrulesUBN$.ubnId.$error" class="text-sm text-danger">
                    {{ vrulesUBN$.ubnId.$errors[0].$message }}
                </span>
            </div>
          </div>
        </div>        
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateUBN" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('missing.Update_missing_from_UBN') }}</button>
        </div>
      </div>
    </div>    
    <div id="animal" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header pb-3">
        <h5>{{ $t('missing.Animal') }}</h5>
        <p class="mb-0 text-sm">{{ $t('missing.Select_one_or_more_animals_missing') }}</p>
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-12">
            <div class="mb-4">
              <p class="fw-bold text-sm">{{ $t('missing.Selected_animals') }} ({{ selectedAnimals.length }})</p>
              <div class="row">
                <div v-for="animal in selectedAnimals" :key="animal.id" class="col-md-6 mb-1">
                  <div class="card border  text-sm border-success bg-light" @click="toggleSelectAnimal(animal)">                    
                    <span v-html="displayText(animal)"></span>
                    <span 
                      class="text-danger position-absolute top-1 end-0"
                      style="cursor: pointer; font-weight: bold; font-size: 25px; margin-right: 10px;"
                      @click.stop="toggleSelectAnimal(animal)"
                    >
                      ×
                    </span>
                  </div>
                </div>
                <p class="text-danger text-sm" v-if="selectedAnimals.length === 0" style="margin-bottom: 2px !important;">
                  {{ $t('common.No_animal_selected') }}
                </p>
                <p class="text-danger text-sm" v-if="vrulesAnimals$.selectedAnimalIds.$error">
                  {{ vrulesAnimals$.selectedAnimalIds.$errors[0].$message }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-6">
            <!-- Search Input -->
            <div class="input-group input-group-static null">
              <label class="">{{ $t('missing.Search') }}</label>
              <input v-model="state.searchQueryAnimal" type="text" class="form-control form-control-default" :placeholder="$t('missing.Search_UBN_studbooknumber_animalnumber_name')"> 
            </div>
          </div>
          <div class="col-12 mt-3">
            <!-- Available Animals -->
            <p class="fw-bold text-sm">
                {{ $t('missing.Available_animals') }}
            </p>

            <div class="available-animals-list">
                <div class="row">
                    <div
                        v-for="animal in filteredAnimals"
                        :key="animal.animalId"
                        class="col-md-6 mb-1"
                    >
                        <div
                            class="card border text-sm"
                            :class="{'border-success bg-light': isSelectedAnimal(animal.animalId), 'cursor-pointer': true}"
                            @click="toggleSelectAnimal(animal)"
                        >
                            <span v-html="displayText(animal)"></span>
                        </div>
                    </div>
                </div>
            </div>            
          </div>         
        </div>        
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateAnimal" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('missing.Update_animal') }}</button>
        </div>
      </div>
    </div>
    <div id="date" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('missing.Date_of_missing') }}</h5>           
        <p class="mb-0 text-sm">{{ $t('common.Mandatory_informations') }} *</p>        
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-4">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('missing.Date_of_missing') }} *</label>
                <input v-model="state.missingDate" type="date" :max="todayDate" class="form-control form-control-default" :placeholder="$t('missing.Date_of_missing')">
                <span v-if="vrulesDates$.missingDate.$error" class="text-sm text-danger">
                    {{ vrulesDates$.missingDate.$errors[0].$message }}
                </span>
                <span v-if="showPastDateWarning" class="text-sm text-danger d-block mt-2">
                  {{ $t('missing.7_days_message') }}
                </span>
            </div>
          </div>          
        </div> 
        <div class="row mt-4">
          <div class="col-12">
            <button v-on:click="updateDate" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('missing.Update_date_of_missing') }}</button>      
          </div>   
        </div>        
      </div>    
    </div>
    <div id="destructor" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header pb-3">
        <h5>{{ $t('missing.Missing_reason') }}</h5>
        <p class="text-sm">{{ $t('common.Mandatory_informations') }} *</p>
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-8">
              <div class="input-group input-group-static null">
                <label>{{ $t('missing.Missing_reason') }} *</label>
                <select id="missingReasonId" v-model="state.missingReasonId" class="form-control form-control-default">
                    <option value="">{{ $t('missing.Select_missing_reason') }}</option>
                    <option v-for="item in state.missingReasons" :key="item.id" :value="item.id">
                        {{ item.name }}
                    </option>
                </select>
                <span v-if="vrulesReason$.missingReasonId.$error" class="text-sm text-danger">
                    {{ vrulesReason$.missingReasonId.$errors[0].$message }}
                </span>                
              </div>              
          </div>          
        </div>        
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateMissingReason" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('missing.Update_missing_reason') }}</button>
        </div>
      </div>
    </div>
    
    <div id="delete" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('common.Delete') }}</h5>
        <p class="text-sm mb-0">
          {{ $t('common.Once_you_delete_there_is_no_going_back_Please_be_certain') }}
        </p>
      </div>
      <div class="card-body d-sm-flex pt-0">
        <div class="d-flex align-items-center mb-sm-0 mb-4">
          <div>            
            <material-switch id="deleteMissing" name="Delete" v-model="state.deleteMissing" />
          </div>
          <div class="ms-2">
            <span class="text-dark font-weight-bold d-block text-sm">{{ $t('common.Confirm') }}</span>
            <span class="text-xs d-block">{{ $t('common.Delete_for') }} {{ state.ubn }}.</span>
          </div>
        </div> 
        <button class="btn mb-0 bg-gradient-danger btn-sm null null mb-0 ms-2" type="button" :disabled="!state.deleteMissing" @click="deleteMissing" name="button">{{ $t('missing.Delete_missing') }}</button>        
      </div>
    </div>    
  </template>
  
  <script>
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import axios from 'axios'
  import { useVuelidate } from '@vuelidate/core'
  import { required, helpers, } from '@vuelidate/validators'
  import { reactive, computed, nextTick, ref } from 'vue'  
  import { useI18n } from 'vue-i18n'
  import Choices from 'choices.js';


  export default {
    name: "MissingDetailItem",
    setup() {
        
      const { t } = useI18n()
      const todayDate = new Date().toISOString().split('T')[0];  
      const state = reactive ({        
        gets: [],

        id: '',
        type: '',
        associationId: '',
        ubnId: '',
        missingReasonId: '',
        departureUbn: '',
        exportCountryId: '',
        animalIds: '',
        missingDate: null,        

        ubns:[],        
        animals:[],
        missingReasons:[],

        deleteMissing: false,

        selectedAnimalIds: [],
        searchQueryAnimal: ''
    })
    
    const rulesUBN = computed(() => ({
      ubnId: { 
          required: helpers.withMessage(t('common.Required'), required),
          isSelected: helpers.withMessage(t('common.Select_a_ubn'), value => value !== '')
      }
    }))

    const rulesReason = computed(() => ({
      missingReasonId: { 
          required: helpers.withMessage(t('common.Required'), required),
          isSelected: helpers.withMessage(t('common.Select_a_missing_reason'), value => value !== '')
      }
    }))
    
    const displayText = (f) => {
      let parts = [];

      if (f.studbookNumber) parts.push(f.studbookNumber);
      if (f.animalNumber) parts.push(f.animalNumber);
      if (f.name) parts.push(`(${f.name})`);
      if (f.arrivalDate) {
        parts.push(`<span style="color: green">${f.arrivalDate}</span>`);
      }
      if (f.breedCode) parts.push(`(${f.breedCode})`);
      return parts.join(' | ');
    }
    
    const selectedAnimalIds = ref(
      String(state.animalIds || '').split(',').filter(id => id)
    )

    const isSelectedAnimal = (id) => selectedAnimalIds.value.includes(id)

    const toggleSelectAnimal = (animal) => {
      const index = state.selectedAnimalIds.indexOf(animal.id)
      if (index > -1) {
        state.selectedAnimalIds.splice(index, 1)
      } else {
        state.selectedAnimalIds.push(animal.id)
      }
    }
    
    const selectedAnimals = computed(() =>
      state.animals.filter(f => state.selectedAnimalIds.includes(f.id))
    )

    const filteredAnimals = computed(() =>
      state.animals.filter(f =>
        !state.selectedAnimalIds.includes(f.id) &&
        displayText(f).toLowerCase().includes(state.searchQueryAnimal.toLowerCase())
      )
    )

    const rulesAnimals = computed(() => ({
      selectedAnimalIds: {
          required: helpers.withMessage(t('common.Select_at_least_one_animal'), required),
          minOne: helpers.withMessage(t('common.Select_at_least_one_animal'), value => value.length > 0)
        }
    }))

    const showPastDateWarning = computed(() => {
      if (!state.missingDate) return false;

      const selectedDate = new Date(state.missingDate);
      const today = new Date();
      const diffInDays = (today - selectedDate) / (1000 * 60 * 60 * 24);
      
      return diffInDays > 7;
    });

    const rulesDates = computed(() => {
        return {
            missingDate: { required: helpers.withMessage(t('common.Required'), required) }            
        }
    })
    
    const vrulesUBN$ = useVuelidate(rulesUBN, state)    
    const vrulesAnimals$ = useVuelidate(rulesAnimals, state)
    const vrulesDates$ = useVuelidate(rulesDates, state)
    const vrulesReason$ = useVuelidate(rulesReason, state)

    return {
        state,
        isSelectedAnimal,       
        toggleSelectAnimal,
        displayText,
        showPastDateWarning,
        selectedAnimals,
        filteredAnimals,        
        vrulesUBN$,        
        vrulesAnimals$,
        vrulesDates$,
        vrulesReason$,
        todayDate
      }
  },    
  components: {      
    MaterialSwitch,
  },  
  async mounted() {  
      this.id = this.$route.params.id;
      this.type = this.$route.params.type;
      
      try {
            this.$store.commit('setShowLoading', true);
            await this.loadAll();            
        } catch(e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
    },    
    methods: {        
      async loadAll() {
        await this.fetchMissingData(this.id);
        await this.fetchAllUBN();        
        await this.fetchAllMissingReasons();        
        await this.fetchAllAnimal();
      },
      async fetchMissingData(groupGuid) {
        try {
            const response = await axios.get(`missing/group/${groupGuid}`);
            this.gets = response.data;
            
            if (this.gets.success) {
                this.state.missing = this.gets.data;

                this.state.associationId = this.state.missing.associationId;
                this.state.id = this.state.missing.id;
                this.state.groupGuid = this.state.missing.groupGuid;
                this.state.ubnId = this.state.missing.ubnid;

                this.state.missingReasonId = this.state.missing.missingReasonId;
                
                this.state.animalIds = this.state.missing.animalIds;
                this.state.missingDate = this.state.missing.missingDate;
                
                this.state.selectedAnimalIds = this.state.missing.animalIds
                                              ? this.state.missing.animalIds.split(',').map(id => id.trim())
                                              : [];

            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch(e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
      },
      async fetchAllUBN()
      {
          try { 
              const response = await axios.get("Location/getallbyassociation", {
                  params: {
                      associationId: this.state.associationId
                  }
              });
              const result = response.data;

              if (result.success && Array.isArray(result.data.locationList)) {
                  this.state.ubns = result.data.locationList;

                  await nextTick();

                  this.initializeChoicesDropdown({
                      id: "ubnId",
                      dataList: this.state.ubns,
                      selectedValue: this.state.ubnId,
                      instanceKey: "choicesInstanceUBN"
                  });
              } else {    
                  this.$showSuccess('errors.Error_fetching_ubns');
              }                
          } catch (e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },
      async fetchAllMissingReasons()
      {
          try { 
              const response = await axios.get("reference/getreference", {
                  params: {
                      referenceTypeId: '1f2470eb-def0-462b-ac42-c03f2a01a33c'
                  }
              });
              const result = response.data;                             

              if (result.success && Array.isArray(result.data)) {

                  this.state.missingReasons = result.data;
                  await nextTick();

                  this.initializeChoicesDropdown({
                      id: "missingReasonId",
                      dataList: this.state.missingReasons,
                      selectedValue: this.state.missingReasonId,
                      instanceKey: "choicesInstanceMissingReason"
                  });
              } else {    
                  this.$showSuccess('errors.Error_fetching_missingreasons');
              }   
          } catch (e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },       
      async fetchAllAnimal() 
      {
          try { 
              const response = await axios.get("Animal/getalldeparture", {
                  params: {
                      associationId: this.state.associationId,                        
                      animalTypeId: '1469f04a-a84e-48a5-b79b-bd69f3a5bd51',
                      ubnId: this.state.ubnId
                  }
              });
              const result = response.data;

              if (result.success && Array.isArray(result.data)) {
                  this.state.animals = result.data.sort((a, b) => (b.animalNumber ?? '').localeCompare(a.animalNumber ?? ''));
              } else {    
                  this.$showSuccess('errors.Error_fetching_animals');
              }                
          } catch (e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },      
      initializeChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
          const element = document.getElementById(id);
          if (!element || element.tagName !== "SELECT") {
              console.error(`Choices: Invalid or missing select element with ID "${id}".`);
              return;
          }

          // Destroy previous instance if it exists
          if (this[instanceKey]) {
              this[instanceKey].destroy();
          }

          // Initialize new Choices instance
          this[instanceKey] = new Choices(element, {
              searchEnabled: true,
              itemSelectText: '',
              shouldSort: false,
              placeholder: true,
          });

          // Set selected value if it exists in list
          if (selectedValue) {
              const optionExists = dataList.some(item => item.id === selectedValue);
              this[instanceKey].setChoiceByValue(optionExists ? [selectedValue] : '');
          }
      },                    
      async updateUBN() {   
        try {
            this.$store.commit('setShowLoading', true);

            this.vrulesUBN$.$validate();
            
            if(!this.vrulesUBN$.$error) {
                const response = await axios.put('missing/updateubn', {
                  "groupGuid": this.state.groupGuid,
                  "ubnId": this.state.ubnId                  
                });
                this.gets = response.data;

                if (this.gets.success) {
                  
                  this.$showSuccess('errors.Success_missing_ubn_updated_successfully');
                  
                  this.$router.push({ path: `/missing/edit/${this.state.groupGuid}` }).then(() => {
                    this.fetchMissingData(this.state.groupGuid);
                  });
                } else {
                  this.$showError('errors.Contact_system_admin');
                }
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },      
      async updateAnimal() {   
        try {
            this.$store.commit('setShowLoading', true);
            this.vrulesAnimals$.$validate();
            
            if(!this.vrulesAnimals$.$error) {

              const response = await axios.put('missing/updateanimal', {
                "groupGuid": this.state.groupGuid,                         
                "animalIds": this.state.selectedAnimalIds.join(',')                
              });
              this.gets = response.data;

              if (this.gets.success) {
                this.$showSuccess('errors.Success_missing_animal_updated_successfully');
                
                this.$router.push({ path: `/missing/edit/${this.state.groupGuid}` }).then(() => {
                  this.fetchMissingData(this.state.groupGuid); // Trigger data refresh or any required action
                });
              } else {
                this.$showError('errors.Contact_system_admin');
              }
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      async updateMissingReason() {   
        try {
          this.$store.commit('setShowLoading', true);

          this.vrulesReason$.$validate();
            
          if(!this.vrulesReason$.$error) {
              const response = await axios.put('missing/updatemissingreason', {
                "groupGuid": this.state.groupGuid,
                missingReasonId: this.state.missingReasonId
              });
              this.gets = response.data;

              if (this.gets.success) {
                
                this.$showSuccess('errors.Success_missing_reason_updated_successfully');
                
                this.$router.push({ path: `/missing/edit/${this.state.groupGuid}` }).then(() => {
                  this.fetchMissingData(this.state.groupGuid);
                });
              } else {
                this.$showError('errors.Contact_system_admin');
              }
          }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },  
      async updateDate() {   
        try {
            this.$store.commit('setShowLoading', true);            
            
            const valid = await this.vrulesDates$.$validate();
            if (!valid) return;

            const response = await axios.put('missing/updatedate', {
              groupGuid: this.state.groupGuid,
              missingDate: this.state.missingDate
            });
            this.gets = response.data;

            if (this.gets.success) {
              this.$showSuccess('errors.Success_missing_date_updated_successfully');
              
              this.$router.push({ path: `/missing/edit/${this.state.groupGuid}` }).then(() => {
                this.fetchMissingData(this.state.groupGuid); // Trigger data refresh or any required action
              });
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },

      /* Confirm delete */
      confirmDelete() {          
          this.state.deleteMissing = !this.state.deleteMissing;
      },

      /* Delete departure */
      deleteMissing() {
          if (this.state.deleteMissing) {
              this.deleteMissing1(
                  this.state.groupGuid
              );
          }
      },
      async deleteMissing1(groupGuid) {

        if (!groupGuid) {
            return;
        }

        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.delete("missing/group/" + groupGuid);
            this.gets = response.data;

            if (this.gets.success) {

              this.$showSuccess('errors.Success_missing_record_deleted_successfully');
              
              this.$router.push('/missing');                
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {          
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      }
    }
  };
  </script>
  <style scoped>
  .card {
    transition: background-color 0.2s ease-in-out;
    cursor: pointer;
    position: relative;
    padding: 10px !important;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .bg-light {
    background-color: #f9f9f9 !important;
  }
  .border-success {
    border-color: #28a745 !important;
  }

    .available-animals-list {

        max-height: 400px;
        overflow-y: auto;
        overflow-x: hidden;

        padding: 6px 12px 6px 4px;
        border: 1px solid #e9ecef;
        border-radius: 10px;
        background: #fafafa;

        scrollbar-width: thin;
        scrollbar-color: #adb5bd transparent;
    }

    .available-animals-list::-webkit-scrollbar {
        width: 7px;
    }

    .available-animals-list::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 10px;
    }

    .available-animals-list::-webkit-scrollbar-thumb {
        background: #adb5bd;
        border-radius: 10px;
    }

    .available-animals-list::-webkit-scrollbar-thumb:hover {
        background: #6c757d;
    }
</style>